/* Match Stream Chat's supported (global) class names. */
.streamOverrides {
  :global(.str-chat.messaging) {
    position: absolute;
    width: 100vw;
    top: env(safe-area-inset-top);
    bottom: env(safe-area-inset-bottom);
    height: 100%;
    padding: 0;
    margin: 0;

    :global(.str-chat__main-panel) {
      padding: 0;
      margin: 0;
    }

    :global(.str-chat__reverse-infinite-scroll) {
      padding-top: 0;
    }
  }
}
